import React from 'react';

import BaseComponent from 'src/components/BaseComponent';

import model from './model';
import NavigationButtons from './NavigationButtons';
import { lang } from 'src/helpers';
import { DropProgressBox } from 'src/components/complex';
import SVGIcon, { GENERAL_ICONS } from 'src/components/svg';
import { MCButton } from 'src/components/basic';
import QRCode from 'src/components/basic/QRCode';

export default class Treatments extends BaseComponent {
  bottomRef = null;
  componentDidMount() {
    model.subscribe(this.subscription);
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
  }

  render() {
    const { loading, error, errorMessage } = model.getApiState('updateCertificate');
    let showNavigationButtons = false;
    return (
      <>
        {!!error && <p className='mc-error'>{errorMessage}</p>}
        <div className='mc-form'>
          <div className={'mc-flex-col'}>
            {/*<div className={'mc-label-416'}>{lang.t('Upload Certificates')}</div>*/}
            <div className={'mc-flex-30-col mc-media-drop-progress-box template-1'}>
              <DropProgressBox
                accept={{
                  'image/*': [],
                  'application/pdf': ['.pdf']
                }}
                onUpload={(n, file) => {
                  this.props.next();

                  setTimeout(() => {
                    model.emit('openCertificateForm', {
                      file
                    });
                  }, 100);
                }}
                childComp={() => {
                  return (
                    <>
                      <SVGIcon iconname={GENERAL_ICONS.UPLOAD} />
                      <div style={{ textAlign: 'center' }}>
                        {lang.t(
                          'Add your diploma to finish your signup and be available for people to find you'
                        )}
                      </div>
                      <MCButton
                        label={'Next'}
                        primary
                        medium
                        dark
                        radius
                        onClick={this.props.next}
                      />
                    </>
                  );
                }}
              />
            </div>
            <QRCode action='cert' handoff={true} size={256} className='mc-qr-section mc-mtb20'>
              <div className='mc-mt10 mc-qr-description'>
                {lang.t('Scan to upload from mobile')}
              </div>
            </QRCode>
          </div>
          <div className={'mc-grow'} />
        </div>
        {showNavigationButtons && (
          <NavigationButtons
            prev={this.props.prev}
            next={() => model.saveCertificate((err) => !err && this.props.next())}
            loading={loading}
          />
        )}
      </>
    );
  }
}
